export default (from, uid) => from === uid



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/is_message_owned_by_user.js
 **/